import { render } from "./PraticaVoltura.vue?vue&type=template&id=5ead2120&scoped=true"
import script from "./PraticaVoltura.vue?vue&type=script&lang=js"
export * from "./PraticaVoltura.vue?vue&type=script&lang=js"

import "./PraticaVoltura.vue?vue&type=style&index=0&id=5ead2120&scoped=true&lang=css"

import exportComponent from "/Users/gigi/Library/ask_admin-deps/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ead2120"]])

export default __exports__